var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.588591 0.215694L0.646447 0.146447C0.820013 -0.0271197 1.08944 -0.046405 1.28431 0.0885911L1.35355 0.146447L6 4.793L10.6464 0.146447C10.8417 -0.0488154 11.1583 -0.0488154 11.3536 0.146447C11.5488 0.341709 11.5488 0.658291 11.3536 0.853553L6.707 5.5L11.3536 10.1464C11.5271 10.32 11.5464 10.5894 11.4114 10.7843L11.3536 10.8536C11.18 11.0271 10.9106 11.0464 10.7157 10.9114L10.6464 10.8536L6 6.207L1.35355 10.8536C1.15829 11.0488 0.841709 11.0488 0.646447 10.8536C0.451185 10.6583 0.451185 10.3417 0.646447 10.1464L5.293 5.5L0.646447 0.853553C0.47288 0.679987 0.453595 0.410563 0.588591 0.215694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseWhite);
export default __webpack_public_path__ + "static/media/x-close-white.caa85f887e4b6efdccc60bd99882271d.svg";
export { ForwardRef as ReactComponent };